"use client";

import type { ReactNode } from "react";
import { useCabinet } from "./Context";

export function MaterialsItem({ children }: { children: ReactNode }) {
	const { openSampleDialog, setOpenSampleDialog } = useCabinet();

	return (
		<button
			type="button"
			onClick={() => setOpenSampleDialog(!openSampleDialog)}
			className="group m-2 flex w-full max-w-[calc(310px/1.6)] shrink-0 cursor-pointer snap-start appearance-none flex-col overflow-hidden rounded-xl border border-shades bg-white text-primary-medium leading-tight first:ml-0 last:mr-0 hover:underline focus:outline-none focus-visible:underline"
		>
			{children}
		</button>
	);
}
